// Global screen wrapper for screen. Was kept in case we need it for later versions.

import React, { ReactNode } from 'react'

export default function ScreenWrapper({ children }: { children: ReactNode }) {
  return <>{children}</>
}
